import { render } from "./Tape.vue?vue&type=template&id=0f171f8b"
import script from "./Tape.vue?vue&type=script&lang=js"
export * from "./Tape.vue?vue&type=script&lang=js"

import "./Tape.vue?vue&type=style&index=0&id=0f171f8b&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__